import {Types} from 'mongoose';
import {STEP_STATUS as status, STEPS as steps, STEP_INTERPRETER_TYPE as types} from './step.const';

export const STEPS = {
    type: 'Steps',
    category: 'System',
    value: steps.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
};

export const STEP_INTERPRETER_TYPE = {
    type: 'Interpreter Type',
    category: 'System',
    value: types.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
};

export const STEP_STATUS = {
    type: 'Step Status',
    category: 'System',
    value: status.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
};
